import { BaseNote } from './base-note.dto';
import { Order } from './order.dto';

export class OrderNote extends BaseNote {
  order?: Order;
}
